<atom-modal-wrapper [modalId]="modalId" size="xl" [modalTemplate]="formHistory">
    <ng-template #formHistory>
        <organism-modal [modalTitle]="getTitle()">
            <div class="flex-grow-1 d-flex flex-column overflow-hidden h-100">
                <wdx-ff-form-history
                    class="flex-grow-1 overflow-hidden"
                    [formId]="formId"
                    [entityId]="entityId"
                ></wdx-ff-form-history>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
                </div>
            </div>
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
